const sortByPropertyValue = propertyName => (a, b) => {
    if (a[propertyName] < b[propertyName]) {
        return -1;
    }

    if (a[propertyName] > b[propertyName]) {
        return 1;
    }

    return 0;
};

export default sortByPropertyValue;
